import { createSlice } from '@reduxjs/toolkit';
import { CustomerPortalModel } from '../../Helpers/Interfaces/CustomerPortalModel';

const initialState: CustomerPortalModel = {
    productShowcase1: {
        "title": "", /*Recommended for you*/
        "products": [],
        "isPublished": true
    },
    productShowcase2: {
        "title": "", /*Exclusive Black Friday Week Deals*/
        "bg": "",
        "bgType": "color",
        "textColor": "",
        "btnColor": "",
        "isPublished": true,
        "products": []
    },
    productShowcase3: {
        "title": "", /*Top Black Friday Week Picks*/
        "products": [],
        "isPublished": false
    },
    productShowcase4: {
        "title": "", /*Where to Find the Deals*/
        "products": [],
        "isPublished": false
    },
    productShowcase5: {
        "title": "", /*Gaming Picks for Black Friday Week*/
        "products": [],
        "isPublished": true
    },
    productShowcase6: {
        "title": "", /*Apparel*/
        "products": [],
        "isPublished": false
    }
}

const CustomerPortalLayoutSlice = createSlice({
    name: 'CustomerPortalLayoutSlice',
    initialState: initialState,
    reducers: {
        setProductShowcaseAll: (state, action) => {
            state.productShowcase1 = action.payload.productShowcase1;
            state.productShowcase2 = action.payload.productShowcase2;
            state.productShowcase3 = action.payload.productShowcase3;
            state.productShowcase4 = action.payload.productShowcase4;
            state.productShowcase5 = action.payload.productShowcase5;
            state.productShowcase6 = action.payload.productShowcase6;
        },
        setProductShowcase1: (state, action) => {
            state.productShowcase1 = action.payload;
        },
        setProductShowcase2: (state, action) => {
            state.productShowcase2 = action.payload;
        },
        setProductShowcase3: (state, action) => {
            state.productShowcase3 = action.payload;
        },
        setProductShowcase4: (state, action) => {
            state.productShowcase4 = action.payload;
        },
        setProductShowcase5: (state, action) => {
            state.productShowcase5 = action.payload;
        },
        setProductShowcase6: (state, action) => {
            state.productShowcase6 = action.payload;
        },
    },
});

export const {setProductShowcaseAll, setProductShowcase1, setProductShowcase2, setProductShowcase3, setProductShowcase4, setProductShowcase5, setProductShowcase6 } = CustomerPortalLayoutSlice.actions;
export default CustomerPortalLayoutSlice;